import type { WorkspaceEntityStore } from '#layers/runtime/entity-store/registry';
import { createWorkspaceRuntimeManager } from './manager';

/**
 * The one workspace runtime lifecycle (ADR 049). The app passes the runtime factory and
 * preparation/publication hooks to each `switchRuntime()` call; layers observe `activeRuntime`,
 * `state`, and `onTransition`.
 */
export const workspaceRuntime = createWorkspaceRuntimeManager<WorkspaceEntityStore>();
